/**
 * Game type preview data derived from the central gameExamples registry.
 * Provides per-game-type image for use by GameTypes.js and PublicGameCreator.
 */
import { getExampleByGameType } from './gameExamples';

/** Returns preview data for a game type: { primary, secondaries }. */
export function getGameTypePreview(gameTypeId) {
  const example = getExampleByGameType(gameTypeId);
  return {
    primary: {
      imageUrl: example?.imageUrl ?? null,
    },
    secondaries: [],
  };
}

/** Returns the primary preview only. */
export function getGameTypePrimaryPreview(gameTypeId) {
  const { primary } = getGameTypePreview(gameTypeId);
  return primary;
}
